import React from "react"
import { Switch, Route } from "react-router"
import { AnimatePresence } from "framer-motion"
import Makers from "./Makers"
import Visionaries from "./Visionaries"
import Postmark from "./Postmark"
import Future from "./Future"
import { AboutPath } from "../../routes"
import {
  TileImage,
  FogBox,
  BackgroundWraper,
  TitleWraper,
  MainTitle,
  SubTitle,
  AboutCard,
  AboutContainer
} from "./AboutUs.style.js"

const AboutCarder = ({ data }) => {
  return (
    <AboutCard
      onClick={() => {
        window.location = `${AboutPath}/${data.mainTitle.toLowerCase()}`
      }}
    >
      <TitleWraper>
        <MainTitle>{data.mainTitle}</MainTitle>
        <SubTitle>{data.subTitle}</SubTitle>
      </TitleWraper>
      <BackgroundWraper>
        <TileImage alt="" src={data.image} />
        <FogBox backgroundColor={data.fogColor}></FogBox>
      </BackgroundWraper>
    </AboutCard>
  )
}

const pageVariants = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}

const pageTransition = {
  ease: "easeIn",
  duration: 0.8
}

const MainAboutUs = () => {
  return (
    <AboutContainer
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      {fetchData.map((data, index) => (
        <AboutCarder key={index} data={data} />
      ))}
    </AboutContainer>
  )
}

const fetchData = [
  {
    mainTitle: "Taylor Wimpey",
    subTitle: "THE MAKERS",
    fogColor: "rgba(97, 125, 148, 0.8)",
    image: "/assets/images/about/img-1c.jpg",
    component: Makers
  },
  {
    mainTitle: "The Architects",
    subTitle: "THE VISIONARIES",
    fogColor: "rgba(141, 176, 173, 0.8)",
    image: "/assets/images/about/img-1d.jpg",
    component: Visionaries
  },
  {
    mainTitle: "Postmark",
    subTitle: "THE HISTORY",
    fogColor: "rgba(11, 37, 60, 0.8)",
    image: "/assets/images/about/img-1b.jpg",
    component: Postmark
  },
  {
    mainTitle: "Enquiries",
    subTitle: "YOUR FUTURE HOME",
    fogColor: "rgba(59, 104, 112, 0.8)",
    image: "/assets/images/about/img-1a.jpg",
    component: Future
  }
]

function AboutUs({ match: { url } }) {
  return (
    <AnimatePresence>
      <Switch>
        <Route exact path={url} component={MainAboutUs} />
        {fetchData.map(({ mainTitle, component: Component }, index) => (
          <Route key={index} path={`${url}/${mainTitle}`} component={Component} />
        ))}
      </Switch>
    </AnimatePresence>
  )
}

export default AboutUs
